import { useState } from 'react';
import CelebrationList from './CelebrationList';
import './CelebrationSettingForm.scss';
import { CELEBRATION_STYLE_KEY } from '../../../constants/PlayPreferenceConstant';
import CelebrationStyleSetting from '../../mysettings/settings/celebrations/CelebrationStyleSetting';
import SimpleCelebration from './simple-celebration/SimpleCelebration';
import SoundEffectSetting from '../sound-effect-setting/SoundEffectSetting';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
// import SeasonalFilter from '../../mystudent/components/settings/seasonal/SeasonalFilter';

const defaultProps = {
  profile: {},
  terminologies: {},
  onChangeCallback: () => {},
  SeasonalFilterComponent: () => null,
};

export default function CelebrationSettingForm(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, terminologies, onChangeCallback, SeasonalFilterComponent } = mergedProps;
  const [internalCelebrationStyle, setInternalCelebrationStyle] = useState(profile.celebrationStyle);
  const showCelebrationDetail = internalCelebrationStyle === CELEBRATION_STYLE_KEY.interactive;

  return (
    <div className='celebration-setting-form' data-test='celebration-setting-form'>
      <div className='celebration-style-container'>
        <CelebrationStyleSetting
          profile={profile}
          onChangeCallback={(newValue) => {
            setInternalCelebrationStyle(newValue);
            onChangeCallback({ celebrationStyle: newValue });
          }}
        />

        {[CELEBRATION_STYLE_KEY.interactive, CELEBRATION_STYLE_KEY.simple].includes(internalCelebrationStyle) && (
          <SoundEffectSetting
            profile={profile}
            onChangeCallback={(newValue) => onChangeCallback({ celebrationSound: newValue })}
            attributeName='celebrationSound'
          />
        )}
        {[CELEBRATION_STYLE_KEY.interactive].includes(internalCelebrationStyle) && (
          // <SeasonalFilter />
          <SeasonalFilterComponent />
        )}
      </div>
      {!showCelebrationDetail && internalCelebrationStyle === CELEBRATION_STYLE_KEY.simple && (
        <SimpleCelebration />
      )}
      {showCelebrationDetail && (
        <CelebrationList
          profile={profile}
          terminologies={terminologies}
          onChangeCallback={(newValue) => onChangeCallback({ celebrations: newValue })}
        />
      )}
    </div>
  );
}
